module.exports = __webpack_public_path__ + "static/media/ice-cream.e9d5e64c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tangible/ice-cream.mp3
// module id = 741
// module chunks = 0